import { addDate } from 'src/helpers/date_helper';
import { CHART_VARIANTS_LIST } from '../ui/chart_menu_actions_helpers';
import { DEFAULT_CHART_HEIGHT } from './chart_config';
//Types
import type { ChartDataInterface } from 'src/types/Chart';
import type { PowerPricesData } from 'src/types/PowerPrices';

export const getTariffIntervalsChartConfig = (
	powerPrices: PowerPricesData,
	units: string,
	range: number,
	startWeekOnSun = false,
): ChartDataInterface => {
	const data = [],
		schedule = powerPrices.schedule,
		startDate = Date.UTC(2023, 0, 1, 0, 0, 0, 0),
		sunday = [],
		series = [];
	for (let i = 0; i < schedule.length; ++i) {
		if (range >= 0 && i != range) continue;
		const date = i > 0 ? addDate(startDate, 'd', i) : startDate;
		for (let j = 0; j < schedule[i].length; ++j) {
			const tariffID = schedule[i][j],
				tariff = powerPrices.tariffs[tariffID],
				dateset = {
					dt: addDate(date, 'i', j * 30).getTime(),
					value: tariff?.price || 0,
					name: tariff?.name || '',
					bgColor: tariff?.bgColor
						? tariff?.bgColor
						: !tariff?.bgColor && tariff?.price > 0
							? 'color-green'
							: undefined,
				};
			i == 0 ? sunday.push(dateset) : data.push(dateset);
		}
	}
	series.push({
		name: 'timeZone',
		data: startWeekOnSun ? [...sunday, ...data] : [...data, ...sunday],
		visible: true,
		style: 'tariff_intervals',
	});
	return {
		name: 'tariffIntervals',
		type: CHART_VARIANTS_LIST[3],
		units,
		rangePeriod: range == -1 ? 'week' : 'day',
		series,
		height: DEFAULT_CHART_HEIGHT,
	};
};
